module.exports = __webpack_public_path__ + "media/images/map_icons/Cycling-874d5a6d6e320abcba0ccd6520d96987.svg";